import { StoreScheduleDetails } from '@services/elastic-search/models';
import { ElasticSearchResponse } from '@services/elastic-search/models/elastic-search-response';
import { StoreDocument } from '@services/elastic-search/models/store-document';
import { LogsService } from '@services/logs';
import { Schedules } from '@shared/components/schedule/model';

export const storeScheduleDetailsSerializer = (
  response: ElasticSearchResponse<StoreDocument>
): StoreScheduleDetails => {
  const schedulesJson = response.hits.hits[0]?._source?.schedules?.[0];
  const specialOpeningJson = response.hits.hits[0]?._source?.special_opening?.[0] ?? undefined;
  const openingDate = response.hits.hits[0]?._source?.opening_date?.[0];

  if (!schedulesJson) {
    return {
      schedules: [],
      specialOpening: [],
      openingDate,
    } satisfies StoreScheduleDetails;
  }

  try {
    return {
      schedules: JSON.parse(schedulesJson) as Schedules[],
      specialOpening: specialOpeningJson ? (JSON.parse(specialOpeningJson) as string[]) : [],
      openingDate,
    };
  } catch (error) {
    LogsService.error(
      'storeScheduleDetailsSerializer',
      'Error during JSON conversion of the schedules and special_opening',
      error,
      {
        schedulesJson,
        specialOpeningJson,
      }
    );
    return {
      schedules: [],
      specialOpening: [],
      openingDate,
    } satisfies StoreScheduleDetails;
  }
};
